import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../services/auth.service";
import {BoxesService} from "../../../services/boxes-service";
import {Box} from "../../../model/box";
import {Constants} from "../../../utils/constants";
import {BoxDialogComponent} from "../box-dialog/box-dialog.component";
import {CreateBoxDialogComponent} from "../create-box-dialog/create-box-dialog.component";
import {switchMap, tap} from "rxjs/operators";
import {EMPTY, Observable, of} from "rxjs";
import {SnackService} from "../../../services/snack.service";
import {SplitCamelCasePipe} from "../../../pipes/split-camel-case.pipe";
import {DialogsService} from "../../../services/dialogs.service";
import {User} from "../../../model/user";


@Component({
  selector: 'aw-box-card',
  templateUrl: './box-card-dashboard.component.html',
  styleUrls: ['./box-card-dashboard.component.scss']
})
export class BoxCardDashboardComponent implements OnInit, AfterViewInit {

  box?: Box;
  boxStatus = Constants.boxStatuses;
  contractStatus = Constants.contractStatuses;
  loading = false;
  disabled = false;
  loggedUser: User;

  @Output() onElementRemoved = new EventEmitter<Box>();


  private box$!: Observable<Box>;

  constructor(
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    public boxesService: BoxesService,
    public authService: AuthService,
    public snackService: SnackService,
    public splitCamelCase: SplitCamelCasePipe,
  ) {
  }

  @Input() set element(element: Box) {
    this.box = element;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.box$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.boxesService.getBox(this.box?.id)),
          tap(x => {
            this.box = x;
            this.loading = false;
          })
        );
  }

  performAction(enabled: boolean): void {
    this.disabled = true;
    this.dialog.open(BoxDialogComponent, {data: {box: this.box, enable: enabled}})
      .afterClosed()
      .pipe(switchMap(value => value ? this.box$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.disabled = false;
          this.snackService.error(error.message);
        }, () => {
          this.disabled = false;
        });
  }

  openEditDialog(): void {
    this.disabled = true;
    this.dialog.open(CreateBoxDialogComponent, {data: this.box})
      .afterClosed()
      .pipe(switchMap(value => value ? this.box$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.disabled = false;
          this.snackService.error(error.message);
        }, () => {
          this.disabled = false;
        });
  }

  deleteBox(): void {
    this.disabled = true;
    this.loading = true;
    this.dialogsService
      .confirm('Delete box', `Are you sure you want to delete the box" ${this.box?.identifier}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxesService.deleteBox(<number>this.box?.id) :
          EMPTY),
        switchMap(() => EMPTY)
      )
      .subscribe(() => {
          this.disabled = false;
          this.onElementRemoved.emit(this.box);
          this.snackService.success('Box deleted!');
          this.loading = false;
        }, (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
          this.loading = false;
        },
        () => {
          this.disabled = false;
          this.loading = false;
        });

  }
}
